import React, { lazy } from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtextedRoute";
import { routes } from "@/config/routes";
import { AccountType } from "@/types";
// const PaymentMethods = lazy(() => import("@/pages/Settings/payment-methods"));
// const BankAccountPage = lazy(
//     () => import("@/pages/Settings/payment-methods/BankAccountPage")
// );
const Users = lazy(() => import("@/pages/Settings/Users"));
const AddEditUser = lazy(() => import("@/pages/Settings/Users/AddEditUser"));
const UserDetails = lazy(() => import("@/pages/Settings/Users/Details"));
const AddressList = lazy(() => import("@/pages/Settings/addresses/AddressList"));
const AddressCreate = lazy(() => import("@/pages/Settings/addresses/AddressCreate"));
const AddressEdit = lazy(() => import("@/pages/Settings/addresses/AddressEdit"));
const PaymentMethods = lazy(() => import("@/pages/PaymentMethods"));
const McpConnections = lazy(() => import("@/pages/Settings/McpConnections"));
const TaxExemption = lazy(() => import("@/pages/Settings/TaxExemption"));

const SettingsRoutes = (
    <React.Fragment>
        {/* Users */}
        <Route
            path={routes.settings.users.root}
            element={<ProtectedRoute><Users /></ProtectedRoute>}
        />
        <Route
            path={routes.settings.users.create}
            element={
                <ProtectedRoute>
                    <AddEditUser />
                </ProtectedRoute>
            }
        />
        <Route
            path={routes.settings.users.details}
            element={
                <ProtectedRoute>
                    <UserDetails />
                </ProtectedRoute>
            }
        />
        {/* Addresses */}
        <Route
            path={routes.settings.addresses.root}
            element={
                <ProtectedRoute allowedAccountTypes={[AccountType.CHANNEL_PARTNER, AccountType.INTERNAL]}>
                    <AddressList />
                </ProtectedRoute>
            }
        />
        <Route
            path={routes.settings.addresses.create}
            element={
                <ProtectedRoute allowedAccountTypes={[AccountType.CHANNEL_PARTNER, AccountType.INTERNAL]}>
                    <AddressCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path={routes.settings.addresses.details}
            element={
                <ProtectedRoute allowedAccountTypes={[AccountType.CHANNEL_PARTNER, AccountType.INTERNAL]}>
                    <AddressEdit />
                </ProtectedRoute>
            }
        />
        {/* AI & MCP connections */}
        <Route
            path={routes.settings.mcp.root}
            element={
                <ProtectedRoute>
                    <McpConnections />
                </ProtectedRoute>
            }
        />
        {/* Payment Methods */}
        <Route
            path={routes.settings.paymentMethods.root}
            element={
                <ProtectedRoute allowedAccountTypes={[AccountType.CHANNEL_PARTNER, AccountType.INTERNAL]}>
                    <PaymentMethods />
                </ProtectedRoute>
            }
        />
        {/* <Route
            path={routes.settings.paymentMethods.linkBankAccount}
            element={
                <ProtectedRoute allowedAccountTypes={[AccountType.CHANNEL_PARTNER, AccountType.INTERNAL]}>
                    <BankAccountPage />
                </ProtectedRoute>
            }
        /> */}
        {/* Tax Exemption — CHANNEL_PARTNER only. Unlike Addresses/Payment
            Methods, this page has no SUPER_ADMIN-side equivalent (the
            backend's GET /tax-certificates/mine is CHANNEL_ADMIN /
            CHANNEL_SALES_REP only — SUPER_ADMIN's view is the Task 12
            /cc/tax-certificates review queue instead), so INTERNAL is
            deliberately excluded here. */}
        <Route
            path={routes.settings.taxExemption.root}
            element={
                <ProtectedRoute allowedAccountTypes={[AccountType.CHANNEL_PARTNER]}>
                    <TaxExemption />
                </ProtectedRoute>
            }
        />
    </React.Fragment>
)

export default SettingsRoutes;
